import React from "react";
import DataUpper from "./dataUpper";
import DataMiddle from "./dataMiddle";
import DataLower from "./dataLower";

export default function Data() {
  return (
    <>
      <DataUpper />
      <DataMiddle />
      <DataLower />
    </>
  );
}
